import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=542ed03c&scoped=true&"
import script from "./ProcessDesign.vue?vue&type=script&lang=js&"
export * from "./ProcessDesign.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=542ed03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ed03c",
  null
  
)

export default component.exports